import TenantComponents from '@components';
export const UserRowActions = (props) => {
  return <TenantComponents.AgencyUserRowActions {...props} />;
};
